import React, {useState, useEffect} from 'react' 
import { Link } from 'react-router-dom' 
import { getGallery } from "../Service/Api";
import Slider from "react-slick";
import LazyLoad from 'react-lazyload';
const HomeGallery = () => {
    const [data, setData] = useState([]); // State for gallery data
    const [loading, setLoading] = useState(true); // State for loading indicator
  
    useEffect(() => {
        const fetchData = async () => {
          try {
            const topperData1 = await getGallery();
            const topperData = topperData1.filter((item) => item.category === 'PhotoGallery'); 
           
            // Sort the data by date in descending order and then slice to get the last 6 entries
            const getcurrentData = topperData
              .sort((a, b) => new Date(b.date) - new Date(a.date))
              .slice(0, 6);
            
            setData(getcurrentData);
          } catch (error) {
            console.error("Error fetching gallery data:", error);
            // Handle error (e.g., show error message)
          } finally {
            setLoading(false); // Set loading to false after data fetching is complete
          }
        };
        fetchData();
      }, []);
    const emptyArray = [
         {id:1},
         {id:2},
         {id:3},
         {id:4},
           ]
      const settings = {
        dots: true,
        autoplay: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        margin: 30,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
           {
              breakpoint: 1500,
              settings: {
                 slidesToShow: 4, 
              }
           },
           {
              breakpoint: 1000,
              settings: {
                 slidesToShow: 3, 
              }
           },
           {
              breakpoint: 700,
              settings: {
                 slidesToShow: 2, 
              }
           }
        ]
     };
  return (
     <> 
     <div className="row">
      <Slider {...settings}>
         {data?.length > 0 ? data?.filter((div) => div.category === "PhotoGallery").map((item, index) => (
            <div className="item" key={index}>
                <div className="project-item">
                    <div className="project-thumb gal-big">
                        <Link to={`/SubGallery?id=${item._id}`}> <LazyLoad> {item.attachments.length > 0 ? (<img src={`https://webapi.entab.info/api/image/${item.attachments
                        [0]}`} className="img-fluid" alt="Sacred Heart School Balia" />) : (<img src="https://webapi.entab.info/api/image/SHSSB/public/Images/demo.jpg" className="img-fluid" alt="Sacred Heart School Balia" />)}</LazyLoad> </Link>
                    </div>
                    <div className="project-content">
                        <h2 className="title">{item.title} </h2>                  
                    </div>
                </div>
            </div>
        )):emptyArray.map((data) => ( 
            <div key={data.id} className='item'>
                <div className="project-item">
                    <div className="project-thumb gal-small">
                        <Link to=" "><LazyLoad><img src="https://webapi.entab.info/api/image/SHSSB/public/Images/demo.jpg" alt="Sacred Heart School Balia" className="img-fluid"/></LazyLoad></Link>
                    </div>
                    <div className="project-content">
                        <h2 className="title">Title </h2>
                        
                    </div>
                </div>
            </div>  
        ))}  
        </Slider> 
     </div>
     </>
  )
}

export default HomeGallery